export default "__VITE_ASSET__Dp2ANeHb__"